/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.16",
    versionName: "0.2.0-nightly.2025.8.16",
    versionChannel: "nightly",
    buildDate: "2025-08-16T00:07:32.192Z",
    commitHash: "900c7c5b36d26082ebc2c456860fa441060f6e67",
};
